import {envAsDateFromDateString, envAsArrayOfNumbers, envAsBoolean} from "./utils/config.utils";

window.appConfig = {
  project: {
    name: process.env.REACT_APP_PROJECT_NAME || "",
    key: process.env.REACT_APP_PROJECT_KEY || "",
  },

  isTestInstance: process.env.REACT_APP_TEST_INSTANCE === "true",
  isProdMode: process.env.NODE_ENV.indexOf("prod") === 0,
  isDebug: process.env.NODE_ENV.indexOf("prod") !== 0
    || process.env.REACT_APP_DEBUG === "true"
    || window.location.href.includes("vicman_debug=1")
    || false,

  build: process.env.REACT_APP_BUILD_INFO || {},

  paths: {
    app: process.env.REACT_APP_APP_PATH,
    assets: process.env.REACT_APP_ASSETS_PATH,
    pwAssets: process.env.REACT_APP_PW_ASSETS_PATH,
    api: process.env.REACT_APP_API_PATH,
    apiUpload: process.env.REACT_APP_API_FILES_PATH,
    apiSign: process.env.REACT_APP_API_SIGN_PATH,
    proxy: process.env.REACT_APP_PW_PROXY_PATH,
    stat: process.env.REACT_APP_STAT_PATH,
    tempImagesUploadEndpoint: process.env.REACT_APP_TEMP_IMAGES_UPLOAD_ENDPOINT,
    imagesStore: process.env.REACT_APP_IMAGES_STORE_ENDPOINT,
    imagesStoreFallback: process.env.REACT_APP_IMAGES_STORE_FALLBACK_ENDPOINT,
    geolocation: process.env.REACT_APP_GEOLOCATION_ENDPOINT,
    processingsAssets: "https://looklab-assets.photo-cdn.net",
    taskImageCache: process.env.REACT_APP_TASK_IMAGE_CACHE_ENDPOINT,
    getContentConfig: process.env.REACT_APP_GET_CONTENT_CONFIG_ENDPOINT,
  },

  photolab: {
    appId: process.env.REACT_APP_PHOTOLAB_APP_ID,
    path: process.env.REACT_APP_PHOTOLAB_API_PATH,
  },

  sentry: {
    isEnabled: envAsBoolean(process.env.REACT_APP_SENTRY_ENABLED),
    dsn: process.env.REACT_APP_SENTRY_DSN || "",
    sampleRate: parseFloat(process.env.REACT_APP_SENTRY_SAMPLE_RATE || 0),
  },

  googleAnalytics: {
    isEnabled: (process.env.REACT_APP_GOOGLE_ANALYTICS_ENABLED === "true") && window.clientConfig.isWeb,
    trackerId: process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKER_ID,
  },

  nativeAds: {
    isEnabled: process.env.REACT_APP_NATIVE_ADS_IS_ENABLED === "true",
  },

  maskEditor: {
    isEnabledInWeb: process.env.REACT_APP_MASK_EDITOR_ENABLED_WEB === "true",
    isEnabledInWebview: process.env.REACT_APP_MASK_EDITOR_ENABLED_WEBVIEW === "true",
  },

  webview: {
    rateAppDialogPercent: parseFloat(process.env.REACT_APP_WEBVIEW_RATEAPP_DIALOG_PERCENT),
  },

  processings: {
    timeout: parseInt(process.env.REACT_APP_PROCESSINGS_TIMEOUT),
    creativeTimeout: parseInt(process.env.REACT_APP_PROCESSINGS_CREATIVE_TIMEOUT),
    creativeStatusNewDuration: parseInt(process.env.REACT_APP_CREATIVE_STATUS_NEW_DURATION) || 0,
    errorButtonTimeout: parseInt(process.env.REACT_APP_PROCESSINGS_ERROR_BUTTON_TIMEOUT),

    creativesRollout: {
      at: envAsDateFromDateString(process.env.REACT_APP_PROCESSINGS_CREATIVES_ROLLOUT_AT) || 0,
      heatingOffset: parseInt(process.env.REACT_APP_PROCESSINGS_CREATIVES_ROLLOUT_HEATING_OFFSET) || 0,
    },

    config: {
      rolloutIsEnabled: envAsBoolean(process.env.REACT_APP_PROCESSINGS_CONFIG_ROLLOUT_ENABLED),
      rolloutInterval: parseInt(process.env.REACT_APP_PROCESSINGS_CONFIG_ROLLOUT_INTERVAL) * 60_000,
      useOldOnUserGroups: envAsArrayOfNumbers(process.env.REACT_APP_PROCESSINGS_CONFIG_OLD_CONFIG_USERGROUPS || ""),
    },

    mobileDesktopModePhotosLimit: parseInt(process.env.REACT_APP_PROCESSINGS_MOBILE_DESKTOP_MODE_PHOTOS_LIMIT || "0"),
    mobilePhotosLimit: parseInt(process.env.REACT_APP_PROCESSINGS_MOBILE_PHOTOS_LIMIT || "0"),

    processSkeleton: {
      isEnabled: envAsBoolean(process.env.REACT_APP_PROCESSINGS_PROCESS_SKELETON_IS_ENABLED),
      countries: (process.env.REACT_APP_PROCESSINGS_PROCESS_SKELETON_COUNTRIES || "").split(","),
    },
    processEaster: {
      countries: (process.env.REACT_APP_PROCESSINGS_PROCESS_EASTER_COUNTRIES || "").split(","),
    }
  },
};
